// filepath: apps/web/src/design-system/error-states/PermissionDenied.tsx
//
// "You don't have access" surface. Per react-conventions and
// ARCHITECTURE_WEB.md §5: no detail beyond the message. The label of a
// forbidden field is never shown — the server has stripped it (INV-2).

import React from "react";

export function PermissionDenied(): React.ReactElement {
  return (
    <div
      data-testid="form-permission-denied"
      className="form-error form-permission-denied"
      role="alert"
    >
      <h2>You don&apos;t have access to this</h2>
      <p>Contact your administrator if you believe this is a mistake.</p>
    </div>
  );
}
